import React, { forwardRef, memo } from 'react';
import classNames from 'classnames';
import { PickerRef } from '@rc-component/picker/es/interface';
import withFloatingLabel, {
  FloatingLabelProps,
} from '@lib/hocs/withFloatingLabel';
import { InputSizes } from '@lib/components/Input/enums';
import TimePicker from './TimePicker';
import styles from './DateTimePicker.module.scss';

type Props = {
  disabled?: boolean;
  hasError?: boolean;
  name?: string;
  onChange: (v: string[]) => void;
  size?: InputSizes;
  value?: string[];
};

const TimeRangePickerCommon = forwardRef(
  (props: Props & FloatingLabelProps, ref: React.ForwardedRef<PickerRef>) => {
    const {
      disabled,
      onChange,
      name,
      value,
      hasError,
      size = InputSizes.large,
    } = props;

    const startValue = value && value[0] ? value[0] : undefined;
    const endValue = value && value[1] ? value[1] : undefined;

    const handleStartChange = (time: string | null | undefined) => {
      const newValue = [time || '', endValue || ''];
      onChange(newValue);
    };

    const handleEndChange = (time: string | null | undefined) => {
      const newValue = [startValue || '', time || ''];
      onChange(newValue);
    };

    return (
      <div className={classNames(styles.rangePickerRow)}>
        <TimePicker
          disabled={disabled}
          hasError={hasError}
          name={`${name}-start`}
          onChange={handleStartChange}
          ref={ref}
          size={size}
          value={startValue}
        />
        <TimePicker
          disabled={disabled}
          hasError={hasError}
          name={`${name}-end`}
          onChange={handleEndChange}
          ref={ref}
          size={size}
          value={endValue}
        />
      </div>
    );
  },
);

export default memo(withFloatingLabel(TimeRangePickerCommon));
